var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.loading,"indicator":_vm.indicator(_vm.icon),"tip":_vm.text}},[_c('div',{style:(_vm.loading ? ("height: " + _vm.height) : '')},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }